import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { App } from './App';
import { useAuthStore } from './stores/authStore';
import './index.css';

// === FIX #1: Initialize auth store BEFORE React (fire-and-forget, async) ===
void useAuthStore.getState().initialize();

// === FIX #16: Global error handler (dev only) ===
if (import.meta.env.DEV) {
    window.onerror = (msg, src, line, col, err) => {
        console.error('[Global Error]', msg, src, line, col, err);
    };
    window.onunhandledrejection = (event: PromiseRejectionEvent) => {
        console.error('[Unhandled Promise]', event.reason);
    };
}

// === Hash-to-path migration for old bookmarks ===
const hash = window.location.hash;
if (hash.startsWith('#/')) {
    const oldPath = hash.substring(1); // "#/coach/home" -> "/coach/home"
    // Map old routes to new
    const routeMap: Record<string, string> = {
        '/coach-login': '/auth/coach/login',
        '/atleta-login': '/auth/athlete/login',
        '/coach/login': '/auth/coach/login',
        '/atleta/login': '/auth/athlete/login'
    };
    const newPath = routeMap[oldPath] || oldPath;
    window.history.replaceState(null, '', newPath);
}

// Service Worker registration
if ('serviceWorker' in navigator) {
    window.addEventListener('load', () => {
        navigator.serviceWorker
            .register('/sw.js')
            .then(reg => {
                reg.addEventListener('updatefound', () => {
                    const newWorker = reg.installing;
                    if (newWorker) {
                        newWorker.addEventListener('statechange', () => {
                            if (newWorker.state === 'activated') {
                                window.location.reload();
                            }
                        });
                    }
                });
            })
            .catch(err => console.warn('SW registration failed:', err));
    });
}

const root = document.getElementById('root');
if (root) {
    createRoot(root).render(
        <StrictMode>
            <App />
        </StrictMode>
    );
}
